import React, { useEffect, useContext, useState } from 'react';
import useWindowDimensions, { formatDate, useStorage } from '../../../../Utils/Utils';
import { ChevronRight, FileText, Users } from 'react-feather';
import { useHistory } from 'react-router-dom';
import { OfferContext } from '../OfferPage';
import { PAGES, ROUTE_PATHS } from '../../../../InternalApiApp';
import { PageContentBodyGrid } from '../../../Shared/Page/Page';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import DetailField from '../../../Shared/DetailSection/DetailField';
import DetailSectionHeader from '../../../Shared/DetailSection/DetailSectionHeader';
import Table from '../../../../components/Table/Table';
import "../FundPage.scss"


const OfferGeneral = ({ portfolio, name }) => {
    const { offer, setOffer, editMode, setSelectedTab, managers, groupings } = useContext(OfferContext)
    const history = useHistory()
    const { width } = useWindowDimensions()

    const [hierarchy, setHierarchy] = React.useState([]);
    const storage = useStorage();

    const [rightDisplayList, setRightDisplayList] = React.useState([]);
    const [rightDisplayHeader, setRightDisplayHeader] = React.useState("Portfolios");
    const [groups, setGroups] = useState([]);
    const [dataMapType, setDataMapType] = useState("group");

    useEffect(() => {
        setSelectedTab("General")
    }, [])

    useEffect(() => {
        storage.getOrFetch("funds/portfolio/groupings/hierarchy").then((hierarchy) => {
            hierarchy = hierarchy.filter((item) => item.displaysInHierarchy).sort((a, b) => a.hierarchyOrder - b.hierarchyOrder).map((item) => item.groupingName);
            setHierarchy(hierarchy);
        })
    }, []);

    useEffect(() => {
        if (!groupings || groupings.length === 0) {
            return;
        }
        let grouping = null;
        if (hierarchy && hierarchy.length > 0) {
            grouping = groupings.filter(grouping => hierarchy[0] === grouping.groupingName);
        }
        if (grouping == null || grouping.length === 0) {
            setGroups([])
            setDataMapType("funds")
            return;
            
        }
        grouping = grouping[0]
        if (grouping == null) {
            setGroups([])
            setDataMapType("funds")
            return;
        } 
        console.log("Groupinginginginging is ", grouping)
        const filtered = grouping.groups && grouping.groups.filter(group => {
            return group.funds?.some(manFundId => {
                return offer.funds.find(offerFund => offerFund.id === manFundId)
            })
        })
        setRightDisplayHeader(grouping.groupingName);
        setGroups(filtered ? filtered : []);
        setDataMapType("group")
    }, [groupings, offer, hierarchy]);

    function updateOffer(newValue, property) {
        // save temporary updates
        const newObj = { ...offer, [property]: newValue }
        setOffer(newObj)
    }

    const fundsColWidths = ['auto', '50px']
    const managersColWidths = ['auto', '50px']
    // const fundsDataMap = (data) => data && data.map((fund, idx) => {
    //     if (dataMapType === 'group') {
    //         const subroute = rightDisplayHeader.toLowerCase().substring(0, rightDisplayHeader.length - 1); // remove last character to account for plural
    //         console.log("Got subroute ", subroute)
    //         return <tr key={idx} className='cursor-pointer portfolio-mgmt-table-row' onClick={() => history.push(ROUTE_PATHS[PAGES.ADMIN] + '/portfolio-management/' + subroute + '/' + fund.groupId)}>
    //             <td>{fund.groupName}</td>
    //             <td className='text-align-right'>
    //                 <ChevronRight className='offer-page-table-chevron' size={16} />
    //             </td>
    //         </tr>
    //     }
    //     return (
    //         <tr key={idx} className='cursor-pointer portfolio-mgmt-table-row' onClick={() => history.push(ROUTE_PATHS[PAGES.ADMIN] + '/fund-management/funds/' + fund.fundNumber)}>
    //             <td>{fund.fundName + " " + fund.fundNumber}</td>
    //             <td className='text-align-right'>
    //                 <ChevronRight className='offer-page-table-chevron' size={16} />
    //             </td>
    //         </tr>
    //     );
    // })

    const dataMap = dataMapType === 'group' ? groupDataMap(groups, history, hierarchy[0]?.toLowerCase()+'s') : fundsDataMap(offer?.funds, history, portfolio);

    return (
        <>
            <PageGridItem container col="1 / span 6" direction='col' gap="xl" style={{ display: 'flex' }}>
                <PageContentBodyGrid rowGap="xl" gridColCount="6" subGrid>
                    <PageGridItem container col="1 / span 6">
                        <DetailSectionHeader header={portfolio ? "Product Details" : "Offer Details"} icon={<FileText />} />
                    </PageGridItem>
                    <PageGridItem col="1 / span 3">
                        <DetailField
                            bold
                            editMode={editMode}
                            onChange={(e) => updateOffer(e.target.value, "offerName")}
                            label={portfolio ? "Product Name" : "Offer Name"}
                            value={offer?.offerName}
                        />
                    </PageGridItem>
                    <PageGridItem col="4 / span 3">
                        <DetailField
                            bold
                            editMode={editMode}
                            onChange={(e) => updateOffer(e.target.value, "offerNumber")}
                            label={portfolio ? "Product Number" : "Offer Number"}
                            value={offer?.offerNumber}
                        />
                    </PageGridItem>
                    <PageGridItem col="1 / span 3">
                        <DetailField
                            bold
                            editMode={editMode}
                            onChange={(e) => updateOffer(e.target.value, "status")}
                            label="Status"
                            value={offer?.status}
                        />
                    </PageGridItem>
                    <PageGridItem col="4 / span 3">
                        <DetailField
                            bold
                            editMode={editMode}
                            onChange={(e) => updateOffer(e.target.value, "offerRegistered")}
                            label="Date Registered"
                            value={offer?.offerRegistered && formatDate(offer?.offerRegistered)}
                        />
                    </PageGridItem>
                    <PageGridItem col="1 / span 3">
                        <DetailField
                            bold
                            editMode={editMode}
                            onChange={(e) => updateOffer(e.target.value, "portalPath")}
                            label="Portal Path"
                            value={offer?.portalPath}
                        />
                    </PageGridItem>
                </PageContentBodyGrid>
            </PageGridItem>
            <PageGridItem container col="7 / span 6" direction='col' gap="xl" style={{ display: 'flex' }}>
                <PageContentBodyGrid rowGap="xl" gridColCount="6" subGrid divider={width < 1200 ? null : 'left'}>
                    <PageGridItem container col="1 / span 6">
                        <div style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '1rem' }}>
                            <DetailSectionHeader header={rightDisplayHeader} icon={<Users />} />
                        </div>
                        <Table
                            minWidth={350}
                            tableStyle={{ maxWidth: 1675 }}
                            colWidths={portfolio ? managersColWidths : fundsColWidths}
                            dataMap={dataMap}
                            id='scheme-and-funds-expandable-table'
                        />
                    </PageGridItem>
                </PageContentBodyGrid>
            </PageGridItem>
        </>

    );
}

const groupDataMap = (data, history, subroute) => {

    if (!data) {
        return null;
    }
    return data.map((fund, idx) => <tr key={idx} className='cursor-pointer portfolio-mgmt-table-row' onClick={() => history.push(ROUTE_PATHS[PAGES.ADMIN] + '/portfolio-management/' + subroute + '/' + fund.groupId)}>
                <td>{fund.groupName}</td>
                <td className='text-align-right'>
                    <ChevronRight className='offer-page-table-chevron' size={16} />
                </td>
            </tr>
    );

}

const fundsDataMap = (data, history, portfolio) => {
    if (!data) {
        return null;
    }
    const basePath = portfolio ? "/portfolio-management/portfolios/": "/fund-management/funds/";    //FIXME - how do we know if this should be fund or portfolio?  
    //const basePath = "/fund-management/funds/"; // for funds
    return data.map((fund, idx) => <tr key={idx} className='cursor-pointer portfolio-mgmt-table-row' onClick={() => history.push(ROUTE_PATHS[PAGES.ADMIN] + basePath + fund.fundNumber)}>
        <td>{fund.fundName + " " + fund.fundNumber}</td>
        <td className='text-align-right'>
            <ChevronRight className='offer-page-table-chevron' size={16} />
        </td>
    </tr>
    );
}

export default OfferGeneral;


